import Model from "../_model";

export default class BatchModel extends Model {
	constructor(provider) {
		super(provider, "batches");
	}

	find(id, { onSuccess, onFail }) {
		return super.find({ id, onSuccess, onFail });
	}

	_parse(o) {
		if (o._id && !o.id) o.id = o._id;
		if (o.id && !o._id) o._id = o.id;
		if (o.createdAt) o.createdAt = this.parseDateTime(o.createdAt);
		if (o.updatedAt) o.updatedAt = this.parseDateTime(o.updatedAt);
		return super._parse(o);
	}

	filter({ filter, pager, sorter, onSuccess, onFail }) {
		return super.filter({
			params: {
				stockId: filter?.stockId,
				quantityStatus: filter?.quantityStatus,
			},
			pager,
			sorter,
			onSuccess: (raw) => {
				const items = Array.isArray(raw) ? raw : raw.items;
				const parsed = items.map(this._parse.bind(this));
				const total = Array.isArray(raw) ? parsed.length : raw.pagination?.totalItemCount ?? parsed.length;

				onSuccess &&
					onSuccess({
						items: parsed,
						pagination: { totalItemCount: total },
					});
			},
			onFail,
		});
	}

	create(instance, { onSuccess, onFail }) {
		const body = {
			stockId: instance.stockId,
			quantity: instance.quantity,
			measurements: instance.measurements.map(({ _id, id, ...rest }) => rest),
			measurement_no: instance.measurement_no,
			weight: instance.weight != null ? instance.weight : undefined,
			images: instance.images || [],
			notes: instance.notes || undefined,
			quantityStatus: instance.quantityStatus,
			visibility: instance.visibility,
		};
		return super.create(body, { onSuccess, onFail });
	}

	update(instance, { onSuccess, onFail }) {
		const body = {
			quantity: instance.quantity,
			measurements: instance.measurements.map(({ _id, id, ...rest }) => rest),
			measurement_no: instance.measurement_no,
			weight: instance.weight != null ? instance.weight : undefined,
			images: instance.images || [],
			notes: instance.notes || undefined,
			quantityStatus: instance.quantityStatus,
			visibility: instance.visibility,
		};
		return super.update(body, { id: instance.id, onSuccess, onFail });
	}

	delete(id, { onSuccess, onFail }) {
		return super.delete({ id, onSuccess, onFail });
	}
}
